import { useState } from 'react'
import { CSVLink } from 'react-csv'

import MoreVertIcon from '@mui/icons-material/MoreVert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { parse } from 'csv-parse/browser/esm/sync'
import Encoding from 'encoding-japanese'

export default function CSVIO({ format, data, onChange, onError }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)

  const csv2json = event => {
    const u8a = new Uint8Array(event.target.result)
    const encoding = Encoding.detect(u8a)
    const csv = Encoding.convert(u8a, { from: encoding, to: 'UNICODE', type: 'string' })

    // eslint-disable-next-line no-unused-vars
    const [keys, names, ..._rows] = parse(csv, {
      skip_empty_lines: true,
      skip_lines_with_empty_values: true,
      trim: true,
      bom: true,
    })

    const rows = _rows.filter(x => x.some(Boolean))
    if (rows.length > 500) {
      onError({
        type: 'TOO_MANY_VALUES',
        message: '一度に登録できるデータ件数は最大 500 件です。',
      })
      return
    }

    const requiredKeys = Object.entries(format)
      .filter(([key, value]) => Boolean(value.required))
      .map(([key]) => key)
    const values = []
    const invalidValues = {}
    rows
      .map(row => {
        const obj = {}
        row.forEach((v, i) => {
          const match = Object.entries(format).find(([key, value]) => key === keys[i])
          if (match) {
            const [key, value] = match
            if (value.convert) {
              v = value.convert(v)
            }
            obj[key] = v
          }
        })
        return obj
      })
      .forEach((value, i) => {
        const rowNumber = i + 3
        const errorField = requiredKeys.find(key => !value[key] || value[key] === '')
        if (!errorField) {
          values.push(value)
        } else if (!invalidValues[errorField]) {
          invalidValues[errorField] = {
            message: format[errorField].required,
            count: 1,
            lines: [rowNumber],
          }
        } else {
          invalidValues[errorField].count++
          invalidValues[errorField].lines.push(rowNumber)
        }
      })

    if (Object.keys(invalidValues).length > 0) {
      onError({
        type: 'HAS_INVALID_VALUES',
        message:
          '一部のデータ形式が正しくありません。以下のエラーを解消した後に再度お試しください。\n\n' +
          Object.entries(invalidValues)
            .map(([field, error]) => {
              let lines = `　行番号: ${error.lines.slice(0, 10).join(',')}`
              if (error.lines.length > 10) {
                lines += ',...'
              }
              return `・${error.message}（${error.count}件）\n${lines}`
            })
            .join('\n\n'),
      })
      return
    }

    onChange(values)
  }

  const handleChange = e => {
    setDialogOpen(false)
    setAnchorEl(null)
    if (e.target.files.length === 0) return
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.onload = csv2json
    reader.readAsArrayBuffer(file)
  }

  const toCSVData = (values = []) => {
    const keys = Object.keys(format)
    const keyNames = keys.map(key => format[key].name)
    const rows = values.map(x => keys.map(key => (x[key] !== undefined ? x[key] : '')))
    return [keys, keyNames, ...rows]
  }

  const handleClickImport = () => {
    setAnchorEl(null)
    setDialogOpen(true)
  }

  return (
    <>
      <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem component="label" onClick={handleClickImport}>
          CSV インポート
        </MenuItem>
        <MenuItem sx={{ '& a': { color: 'text.primary' } }}>
          <CSVLink data={toCSVData(data)} filename="timelylimit.csv">
            CSV ダウンロード
          </CSVLink>
        </MenuItem>
      </Menu>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>CSV インポート</DialogTitle>
        <DialogContent>
          <CSVLink data={toCSVData(data)} filename="timelylimit.csv">
            現在のデータをダウンロード
          </CSVLink>
          するか、
          <CSVLink data={toCSVData()} filename="template.csv">
            CSV テンプレートをダウンロード
          </CSVLink>
          し、編集後にインポートしてください。
        </DialogContent>
        <DialogActions>
          <div style={{ flex: 1 }} />
          <Button onClick={() => setDialogOpen(false)}>キャンセル</Button>
          <Button color="primary" component="label">
            インポート
            <input hidden type="file" accept=".csv" onChange={handleChange} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
